module.exports = __webpack_public_path__ + "media/img/vca/bg-howto-471b1580a5a86822d993966d85b46aca.png";